<template>
  <div
    v-if="testimonials"
    class="w-100 relative h-100"
    style="flex-grow: 1;"
  >
    <BgLeaves
      :trigger="leaves"
      :position="[1, 0, 1, 0]"
      :inset="0"
    />
    <div
      class="flex flex-column items-start justify-center h-100 pr5 w-100 top-0"
      style="padding-left: 25vw;"
    >
      <div
        ref="title"
        class="f1 b mb4"
        :class="{
          'purple': brand === 'lh',
          'dark-gray': brand === 'lq'
        }"
      >
        Testimonials
      </div>
      <div
        ref="devider"
        class="bt bw1 w3"
        :class="{
          'b--purple': brand === 'lh',
          'b--dark-gray': brand === 'lq'
        }"
      />
      <div
        class="relative mt5 pr5"
        style="max-height: 60%;"
      >
        <div
          class="relative slider-content flex justify-between flex-wrap pt4 pr4"
          style="max-height: 100%; overflow-y: auto;"
        >
          <div
            v-for="(item, index) in testimonials"
            :key="index"
            class="mb4 pa4 ba bw1 bg-light b--light-gray br3"
            style="flex: 0 0 31.5%"
          >
            <div
              v-if="item.citation"
              v-html="item.citation"
              class="fw6 f4 mb2 lh-title"
            />
            <div
              v-if="item.location"
              v-html="item.location"
              class="f7 b ttu mb4 lh-title"
              :class="{
                'purple': brand === 'lh',
                'silver': brand === 'lq'
              }"
            />
            <div
              v-if="item.quote"
              class="f6 lh-copy tj"
              v-html="item.quote"
            />
          </div>
        </div>
        <div
          class="absolute top-0 left-0 right-0 mr5"
          style="height: 2rem; margin-right: 5rem; background-image: linear-gradient(to bottom, #F8F9FA, rgba(255,255,255,0))"
        />
        <div
          class="absolute bottom-0 left-0 right-0 mr5"
          style="height: 2rem; margin-right: 5rem; background-image: linear-gradient(to top, #F8F9FA, rgba(255,255,255,0))"
        />
      </div>
    </div>
  </div>
</template>
<script>
import transitions from '../../transitions.js'
import BgLeaves from '@/components/BgLeaves.vue'

export default {
  name: 'Testimonials',
  components: {
    BgLeaves
  },
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    development: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      leaves: false
    }
  },
  computed: {
    testimonials () {
      if (this.$store.state.content) {
        return this.$store.state.content.about.testimonials
      } else {
        return null
      }
    }
  },
  methods: {
    titleAnim () {
      const devider = this.$refs.devider
      const title = this.$refs.title
      if (title && devider) {
        transitions.titleTransition(title, devider)
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
      vm.titleAnim()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  }
}
</script>
